import script from "./DropdownVendedores.vue?vue&type=script&setup=true&lang=ts"
export * from "./DropdownVendedores.vue?vue&type=script&setup=true&lang=ts"

import "./DropdownVendedores.vue?vue&type=style&index=0&id=1d639272&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d639272"]])

export default __exports__